//definition of api methods names with theirs urls

export const
    GET_COMPANIES_BY_TAX = "customer?taxId=",
    GET_COMPANIES_BY_TEXT = "customer/byText?text=",
    GET_PRODUCTS_BY_TEXT = "product?text={text}&complaintType={complaintType}",
    GET_COMPLAINT_BY_ID = "complaint/getComplaintById?complaintId=",
    GET_COMPLAINT_BY_NUMBER = "complaint/getComplaintByNumber?",
    GET_COMPLAINT_TYPES = "complaint/getComplaintTypes?",
    GET_COMPLAINT_POSITION_COMPONENTS = "complaintPositionComponents/getComplaintPositionComponents",
    GET_COURIERS = "couriers",
    GET_CUSTOMER_TYPES = "customer/getCustomersTypes",
    GET_TEXTS = "texts/getTexts",
    GET_QUANTITY_CORRECTIONS_PROPOSAL = "complaint/getQuantityCorrectionsProposals", 
    GET_SETTING_VALUE = "util/getSettingValue?settingName=",
    GET_SETTING_AS_BOOL_VALUE = "util/getBoolSettingValue?settingName=",
    POST_COMPLAINT = "complaint",
    PUT_COMPLAINT_WAYBILL_NUMBER="complaint/putComplaintWaybillNumber",
    VALIDATE_CAPTCHA= "captcha/getCaptchaValidateValue?captchaResponse=",
    GET_SALES_DOCUMENT_ID_BY_NUMBER_AND_CUSTOMER_ID = "documents/byNumberAndCustomer?salesDocumentNumber={salesDocumentNumber}&customerId={customerId}";


// WEBPACK FOOTER //
// ./src/api/ExternalApiUrls.js